import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base";
import { getESGReqHeader } from "./tool-service";

// F1010206	合作組織清單查詢
export const getCompanyList = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010206"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010206")}`, method: "post", data: ReqBody });
};

// F1010201 組織邊界查詢
export const getCompanyPlaceList = async () => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010201"),
    ReqBody: {},
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010201")}`, method: "post", data: ReqBody });
};

// 設備製程列表查詢
export const queryEquipmentProcessList = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060101"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060101")}`, method: "post", data: ReqBody });
};

// 設備製程詳情查詢
export const queryEquipmentProcessDetail = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060102"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060102")}`, method: "post", data: ReqBody });
};

// 設備製程詳情新增
export const F1060103Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060103"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060103", true)}`, method: "post", data: ReqBody });
};

export const createEquipmentProcess = async (reqBody = {}) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1060103")}`, method: "post", data: reqBody });
};

// 設備製程詳情編輯
export const F1060104Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060104"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060104", true)}`, method: "post", data: ReqBody });
};

export const updateEquipmentProcess = async (reqBody = {}) => {
  return await apiS({ url: `/${getTxtIdMapperPath("F1060104")}`, method: "post", data: reqBody });
};

// 設備製程詳情刪除
export const deleteEquipmentProcess = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060105"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060105")}`, method: "post", data: ReqBody });
};

// 產品資訊列表查詢
export const queryProductProcessList = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060201"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060201")}`, method: "post", data: ReqBody });
};

// 產品資訊詳情查詢
export const queryProductProcessDetail = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060202"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060202")}`, method: "post", data: ReqBody });
};

// 產品資訊詳情編輯
export const F1060203Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060203"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060203", true)}`, method: "post", data: ReqBody });
};

export const updateProductProcess = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060203"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060203")}`, method: "post", data: ReqBody });
};

// 設備製程下拉清單
export const queryEquipmentProcessDropdownList = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060204"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060204")}`, method: "post", data: ReqBody });
};

// CBAM 列表查詢
export const queryCbamInspectionList = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060301"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060301")}`, method: "post", data: ReqBody });
};

// CBAM 盤查新增
export const F1060302Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060302"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060302", true)}`, method: "post", data: ReqBody });
};

export const createCbamInspection = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060302"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060302")}`, method: "post", data: ReqBody });
};

// CBAM 盤查更新
export const F1060303Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060303"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060303", true)}`, method: "post", data: ReqBody });
};

export const updateCbamInspection = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060303"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060303")}`, method: "post", data: ReqBody });
};

// CBAM 盤查作廢
export const deleteCbamInspection = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060304"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060304")}`, method: "post", data: ReqBody });
};

// CBAM 盤查詳情查詢
export const queryCbamInspectionDetail = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060305"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060305")}`, method: "post", data: ReqBody });
};

// CBAM盤查製造資訊查詢
export const queryCbamProdManufacturingInfo = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060306"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060306")}`, method: "post", data: ReqBody });
};

// CBAM盤查製造資訊更新
export const F106030601Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030601"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030601", true)}`, method: "post", data: ReqBody });
};

export const updateCbamProdManufacturingInfo = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030601"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030601")}`, method: "post", data: ReqBody });
};

// CBAM盤查排放源查詢
export const queryCbamEmissionSource = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060307"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060307")}`, method: "post", data: ReqBody });
};

// 預設排放源帶入
export const defaultEmissionSourceLoad = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030701"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030701")}`, method: "post", data: ReqBody });
};

// CBAM盤查排放源更新
export const F106030702Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030702"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030702", true)}`, method: "post", data: ReqBody });
};

export const updateCbamEmissionSource = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030702"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030702")}`, method: "post", data: ReqBody });
};

export const queryCbamEnerguUsage = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060308"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060308")}`, method: "post", data: ReqBody });
};

export const F106030801Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030801"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030801", true)}`, method: "post", data: ReqBody });
};

export const updateCbamEnerguUsage = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030801"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030801")}`, method: "post", data: ReqBody });
};

export const queryCbamProcess = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060309"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060309")}`, method: "post", data: ReqBody });
};

export const F106030901Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030901"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030901", true)}`, method: "post", data: ReqBody });
};

export const updateCbamProcess = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106030901"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106030901")}`, method: "post", data: ReqBody });
};

// CBAM 清冊匯出
export const exportCbamInventory = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060320"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("F1060320")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true
  );
};

export const queryCbamPrecursor = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060310"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060310")}`, method: "post", data: ReqBody });
};

export const F106031001Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106031001"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106031001", true)}`, method: "post", data: ReqBody });
};

export const updateCbamPrecursor = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106031001"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106031001")}`, method: "post", data: ReqBody });
};

export const queryCbamProductSummary = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1060311"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1060311")}`, method: "post", data: ReqBody });
};

export const F106031101Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106031101"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106031101", true)}`, method: "post", data: ReqBody });
};

export const updateCbamProductSummary = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F106031101"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F106031101")}`, method: "post", data: ReqBody });
};
